const initialUserState = {
    battery: "",
  };
  
  const GlobalBatteryTypedValue = (state = initialUserState, action) => {
      
    switch (action.type) {
      case "GLobalBatteryTypedValue":
        return {
            ...state,
          battery: action.battery,
      };
      default:
        return state;
    }
  };
  
  
  export default GlobalBatteryTypedValue;
  